import TagManager from "react-gtm-module";

export const trackEvent = (eventName: string, eventData = {}) => {
  const dataLayerArgs = {
    dataLayer: {
      event: 'select_content',
      dl_infos: {
        ...eventData,
        select_content: eventName,
        selling_environment: 'cadastro-e-login',
        shelf: 'acesse-sua-conta',
        page_location: window.location.href,
        timestamp: new Date().toISOString()
      }
    }
  };

  TagManager.dataLayer(dataLayerArgs);
  console.log('layer push', dataLayerArgs);
};

export type EventIdentifierMethod = 'CPF' | 'EMAIL' | 'MEMBER'

export const trackLoginEvents = {
  forgotPassword: () => trackEvent('esqueci-minha-senha'),
  loginMethod: (methodType: EventIdentifierMethod) => {
    const method = methodType.toLowerCase();
    const castMethod = method === 'member' ? 'numero-smiles' : method;

    trackEvent(`login-metodo-${castMethod}`);
  },

  recaptchaClick: () => trackEvent('recaptcha'),
  recaptchaSuccess: () => trackEvent('recaptcha-sucesso'),
  recaptchaContinue: () => trackEvent('recaptcha-continuar'),
  passwordInput: () => trackEvent('inserir-senha'),
  loginContinue: () => trackEvent('continuar-login'),
  AccountNotFound: () => trackEvent('modal-validacao-conta'),
  AccountNotFoundTryAgain: () => trackEvent('tentar-novamente-ja-possui-conta'),
  IncorrectData: () => trackEvent('modal-dados-incorretos'),
  IncorrectDataTryAgain: () => trackEvent('tentar-novamente-dados-incorretos'),
  ModalLastTry: () => trackEvent('modal-ultima-tentativa'),
  ModalLastTryTryAgain: () => trackEvent('tentar-novamente-ultima-tentativa'),
  ModalBlockPassword: () => trackEvent('modal-criar-nova-senha'),
  CreateNewPassword: () => trackEvent('criar-nova-senha'),
};
